<template>
  <div class="full-height">
    <div :class="{
      simpleButtons: rowButtons,
      crudButtons: !rowButtons,
      cleanLayout: cleanLayout
    }" class="row container q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="tw-justify-center q-px-sm">
            <jt-data-table
              ref="datatable"
              v-if="datatable"
              :api-mode="false"
              :data="datatableModel"
              :fields="datatable.columns"
              nonselection
              :is-paginated="true"
            >
              <template #body="{props}">
                <q-tr class="text-left">
                  <q-td v-if="!noneselect && !rowButtons" auto-width>
                    <q-checkbox
                      v-model="props.row.selected"
                      @input="updateSelection(props.row)"
                      color="primary"
                      :id="props.row.id"
                      :dense="true"
                    />
                  </q-td>
                  <q-td v-for="col in props.cols" :key="col.name" :props="props" style="color: #333">
                    <span v-if="col.field == 'invoiceSettlementType'">
                      <button-filter :text="getSettlementTypeByCode(props.row['invoiceSettlementType']).text"
                                     :color="getSettlementTypeByCode(props.row['invoiceSettlementType']).color" />
                    </span>
                    <span v-else>
                      {{ col.value }}
                    </span>
                  </q-td>
                </q-tr>
              </template>
            </jt-data-table>
          </q-card-section>
        </q-card>
      </div>
    </div>

  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtDataTable } from 'jtech-webcomps'
import AnalyzeInvoiceSettlementController from '../AnalyzeInvoiceSettlementController'
import { settlementTypeMap } from '../components/settlementTypeMap.js'

@Component({
  name: 'InvoiceSettlementHistory',
  components: {
    JtDataTable
  },
  props: {
    name: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    columns: { type: Array, required: true },
    selected: Object,
    key: Object
  }
})

class InvoiceSettlementHistory extends Vue {
  analyzeInvoiceSettlementController = AnalyzeInvoiceSettlementController.getInstance();
  data = null;
  allSelected = false
  selectedIds = []

  created () {
    if (this.datatableModel) {
      this.datatableModel = this.datatableModel.map(row => ({
        ...row,
        selected: false
      }))
    }
  }

  async mounted () {
    try {
      await Promise.all([
        this.load(),
        this.loadData(),
        this.loadDatatableModel()
      ])
      this.resetSelection()
    } catch (error) {
      this.$q.notify({
        type: 'negative',
        message: error.message
      })
    }
  }

  resetSelection () {
    this.allSelected = false
    this.selectedIds = []
    if (this.data) {
      this.data.forEach(row => {
        row.selected = false
      })
    }
  }

  updateSelection (row) {
    const isSelected = row.selected || false
    if (isSelected && !this.selectedIds.includes(row.id)) {
      this.selectedIds.push(row.id)
    } else if (!isSelected && this.selectedIds.includes(row.id)) {
      this.selectedIds = this.selectedIds.filter((id) => id !== row.id)
    }
    this.allSelected = this.data && this.data.length > 0 &&
      this.data.every(row => row.selected)
  }

  get settlementType () {
    return settlementTypeMap()
  }

  getSettlementTypeByCode (code) {
    if (code) {
      for (const settlement in this.settlementType) {
        if (
          Object.prototype.hasOwnProperty.call(this.settlementType, settlement)
        ) {
          const settlementKeys = this.settlementType[settlement].keys || []
          if (settlementKeys.includes(code)) {
            return this.settlementType[settlement]
          }
        }
      }
    }
    return { text: code, color: '#fff' }
  }
}

export default InvoiceSettlementHistory
</script>
<style scoped lang="stylus">

</style>
